import { createContext } from 'react';

const AlertaContext = createContext();

export default AlertaContext;